import { BudgetSections } from 'business/constants';

const AP_ID = 'id';
export const NAME_FIELD = 'label';
export const AMOUNT_FIELD = 'apAmountEstimated';
export const REALIZED_FIELD = 'apAmountRealized';
export const PERCENT_REALIZED_FIELD = 'apPercentRealized';

export const AMOUNT_ESTIMATED_YEAR_PREFIX = 'amountEstimated';
export const FULL_AMOUNT_YEAR_PREFIX = 'fullAmount';
export const AMOUNT_REALIZED_YEAR_PREFIX = 'amountRealized';
export const PERCENT_REALIZED_YEAR_PREFIX = 'percentRealized';
export const AMOUNT_REQUESTED_YEAR_PREFIX = 'amountRequested';
export const AMOUNT_ARBITRATED_YEAR_PREFIX = 'amountArbitrated';
export const AMOUNT_VOTED_YEAR_PREFIX = 'amountVoted';
export const AMOUNT_SUPP_YEAR_PREFIX = 'amountSupp';
export const INVESTMENT_OPERATING = 'investmentOperating';

type YearlyField =
    | typeof AMOUNT_ESTIMATED_YEAR_PREFIX
    | typeof FULL_AMOUNT_YEAR_PREFIX
    | typeof AMOUNT_REALIZED_YEAR_PREFIX
    | typeof PERCENT_REALIZED_YEAR_PREFIX
    | typeof AMOUNT_REQUESTED_YEAR_PREFIX
    | typeof AMOUNT_ARBITRATED_YEAR_PREFIX
    | typeof AMOUNT_VOTED_YEAR_PREFIX
    | typeof AMOUNT_SUPP_YEAR_PREFIX;

export type ApT = {
    [AP_ID]: number;
    [NAME_FIELD]: string;
    [AMOUNT_FIELD]: number;
    [REALIZED_FIELD]: number;
    [PERCENT_REALIZED_FIELD]: number;
    [INVESTMENT_OPERATING]: BudgetSections;
    [key: `${YearlyField}..${number}`]: number;
};
